<template>
  <nuttrema-layout-default-slide class="is-lighter">

    <template slot="collapsed-menu-top-brand">
      <nuttrema-brand-image
        hide-in-expanded>
      </nuttrema-brand-image>
    </template>

    <nuttrema-registration-carousel
      slot="expanded-menu-level-zero"
      class="expanded-menu-level-zero is-expanded">
    </nuttrema-registration-carousel>

  </nuttrema-layout-default-slide>
</template>

<script>
import NuttremaLayoutDefaultSlide from 'components/ui/layout/nuttrema-layout-default-slide';

import SidebarMenuLevelAuthCollapsed from 'components/ui/menu/auth/sidebar-menu-level-auth-collapsed';
import SidebarMenuLevelAuthExpanded from 'components/ui/menu/auth/sidebar-menu-level-auth-expanded';

import NuttremaRegistrationCarousel from 'components/ui/carousel/nuttrema-registration-carousel';
import NuttremaBrandImage from 'components/ui/images/nuttrema-brand-image';

export default {
  name: 'layout-set-public-register-instance',
  components: {
    NuttremaBrandImage,
    NuttremaLayoutDefaultSlide,
    SidebarMenuLevelAuthExpanded,
    SidebarMenuLevelAuthCollapsed,
    NuttremaRegistrationCarousel,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/layout-set/public/layout-set-public-register-instance.vue